import React from "react";
import { Icon } from "@iconify/react";
import '../../../styles/Auth/categoryPopup.css';
import { Typography } from "@mui/material";

const ViewServicePopup = ({ data, onClose }) => {
    const renderDescription = (desc) => {
        if (!desc) return null;
        
        const lines = desc.split("\n");
        let currentList = [];
        const rendered = [];

        const flushList = (key) => {
            if (currentList.length > 0) {
                const isDecimal = currentList[0].marker.endsWith(".");
                const Tag = isDecimal ? "ol" : "ul";
                rendered.push(
                    <Tag key={`list-${key}`} style={{ margin: "0 0 12px 20px", paddingLeft: "10px", listStyleType: isDecimal ? "decimal" : "disc", color: "#525252" }}>
                        {currentList.map((item, idx) => (
                            <li key={idx} style={{ marginBottom: "4px" }}>{item.content}</li>
                        ))}
                    </Tag>
                );
                currentList = [];
            }
        };

        lines.forEach((line, index) => {
            const trimmed = line.trim();
            const listMatch = trimmed.match(/^([-*•]|\d+\.)\s+(.*)$/);

            if (listMatch) {
                currentList.push({ marker: listMatch[1], content: listMatch[2] });
            } else {
                flushList(index);
                rendered.push(
                    <p key={index} style={{ margin: "0 0 8px 0", minHeight: trimmed === "" ? "1em" : "auto", whiteSpace: "pre-wrap" }}>
                        {line}
                    </p>
                );
            }
        });

        flushList(lines.length);
        return rendered;
    };

    return (
        <div className="category-detail-overlay">
            <div className="category-detail-modal large">
                <button className="category-detail-close" onClick={onClose}>
                    <Icon icon="solar:close-circle-bold-duotone" width={32} height={32} />
                </button>

                <div className="category-detail-header">
                    <div className="category-detail-image-container">
                        <img
                            src={data?.serviceImageObject?.uri ? `${(process.env.REACT_APP_API_URL || "").replace(/\/+$/, "")}/${data.serviceImageObject.uri.replace(/^\/+/, "")}` : "/assets/placeholder.png"}
                            alt={data.serviceName}
                            onError={(e) => { e.target.onerror = null; e.target.src = "/assets/placeholder.png"; }}
                            className="category-detail-img"
                        />
                    </div>
                    <Typography variant="h4" className="category-detail-title">
                        {data.serviceName || data.title}
                    </Typography>
                    <div className="product-category-badge">
                        <Icon icon="solar:star-bold-duotone" width={14} />
                        <span>Service Detail</span>
                    </div>
                </div>

                <div className="category-detail-content">
                    <div className="category-detail-stats grid-2">
                        <div className="stat-card">
                            <Icon icon="solar:clock-circle-bold-duotone" className="stat-icon" />
                            <div className="stat-info">
                                <span className="stat-label">Duration</span>
                                <span className="stat-value">{data.duration || '0'} Minutes</span>
                            </div>
                        </div>
                        <div className="stat-card">
                            <Icon icon="solar:checklist-minimalistic-bold-duotone" className="stat-icon" />
                            <div className="stat-info">
                                <span className="stat-label">Service Status</span>
                                <span className={`stat-value ${(data.isActive !== undefined ? data.isActive === true : data.serviceStatus === 'Active') ? 'active' : 'inactive'}`}>
                                    {(data.isActive !== undefined ? data.isActive === true : data.serviceStatus === 'Active') ? 'Active' : 'Inactive'}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="price-summary-card">
                        <span className="price-summary-title">Service Multi-Tier Pricing</span>
                        <div className="price-grid">
                            <div className="price-item">
                                <span className="price-label">Retail Price</span>
                                <span className="price-value">₹{data.nonMemberShipPrice || 0}</span>
                            </div>
                            <div className="price-item">
                                <span className="price-label">GST Rate</span>
                                <span className="price-value">{data.gstPercentage || 0}%</span>
                            </div>
                            <div className="price-item">
                                <span className="price-label">Tax Total</span>
                                <span className="price-value">₹{data.gstAmount || "0.00"}</span>
                            </div>
                            <div className="price-item">
                                <span className="price-label">Member Special</span>
                                <span className="price-value highlight">₹{data.memberShipPrice || 0}</span>
                            </div>
                        </div>
                    </div>

                    {data.description && (
                        <div className="price-summary-card" style={{ marginTop: "16px", padding: "16px" }}>
                            <span className="price-summary-title" style={{ display: "block", marginBottom: "12px", borderBottom: "1px solid rgba(0,0,0,0.06)", paddingBottom: "6px" }}>Description</span>
                            <div style={{ fontSize: "14px", color: "#525252", lineHeight: "1.6" }}>
                                {renderDescription(data.description)}
                            </div>
                        </div>
                    )}
                </div>

                <div className="category-detail-footer">
                    <button className="category-detail-action-btn" onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ViewServicePopup;